// extracted by mini-css-extract-plugin
export default {"wrapper":"TextStyleModifiedItem_wrapper__NuI1G","modifiedBar":"TextStyleModifiedItem_modifiedBar__DZUMC"};